import { useTranslation } from "react-i18next";

export default function LanguageSetter(props: { name: string, label: string, callback?: Function }) {
    const { i18n } = useTranslation();
    const callback = props.callback ?? (() => { });
    return <a href="javascript:void(0)" onClick={() => { i18n.changeLanguage(props.name); callback(); }}>{props.label}</a>
}